import React from 'react';
import { ChevronDownIcon, SearchIcon } from 'lucide-react';
export function TopSearchBar() {
  return <div className="bg-white border-b py-3 px-6 sticky top-0 z-10 shadow-sm" data-id="element-616">
      <div className="flex items-center" data-id="element-617">
        <div className="relative flex-1 max-w-3xl" data-id="element-618">
          <div className="flex" data-id="element-619">
            <div className="relative" data-id="element-620">
              <select className="h-10 px-3 bg-gray-100 border-gray-300 border rounded-l-md appearance-none pr-8 text-sm font-medium" data-id="element-621">
                <option data-id="element-622">All</option>
                <option data-id="element-623">Reports</option>
                <option data-id="element-624">Payers</option>
                <option data-id="element-625">Codes</option>
              </select>
              <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" data-id="element-626" />
            </div>
            <input type="text" placeholder="Search..." defaultValue="radiofrequency" className="h-10 flex-1 px-4 py-2 bg-gray-100 border-gray-300 border-y text-sm min-w-[400px] focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-600" data-id="element-627" />
            <button className="h-10 bg-indigo-600 px-4 rounded-r-md border border-indigo-600 hover:bg-indigo-700 transition-colors" data-id="element-628">
              <SearchIcon className="w-5 h-5 text-white" data-id="element-629" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}